export const SocialMediaType = {
    Facebook: 'Facebook',
    Twitter: 'Twitter',
    LinkedIn: 'LinkedIn',
};
